import i18n from 'i18next'

export const getLocale = () => {
  const isEnglish =
    typeof window !== 'undefined'
      ? window.location.pathname.startsWith('/en-ca')
      : false

  return isEnglish ? 'en' : 'fr'
}

export const filterByNodeLocale = (item) => {
  try {
    return item.node_locale.startsWith(i18n.language)
  } catch (e) {
    return false
  }
}
